
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.75 4.846c0 1.02-.84 1.846-1.875 1.846C1.839 6.692 1 5.866 1 4.846S1.84 3 2.875 3c1.036 0 1.875.827 1.875 1.846zM2.875 9.154C1.839 9.154 1 9.98 1 11s.84 1.846 1.875 1.846c1.036 0 1.875-.826 1.875-1.846s-.84-1.846-1.875-1.846zm0 6.154c-1.036 0-1.875.826-1.875 1.846S1.84 19 2.875 19c1.036 0 1.875-.827 1.875-1.846 0-1.02-.84-1.846-1.875-1.846zm3.75-9.077h13.75A.62.62 0 0021 5.615V4.077a.62.62 0 00-.625-.615H6.625A.62.62 0 006 4.077v1.538c0 .34.28.616.625.616zm0 6.154h13.75a.62.62 0 00.625-.616v-1.538a.62.62 0 00-.625-.616H6.625a.62.62 0 00-.625.616v1.538c0 .34.28.616.625.616zm0 6.153h13.75a.62.62 0 00.625-.615v-1.538a.62.62 0 00-.625-.616H6.625a.62.62 0 00-.625.616v1.538c0 .34.28.615.625.615z","fill":"#F1E41E","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_list_ul.svg